import { useEffect, useState } from "react";

/**
 * Vrací hodnotu se zpožděním — pro text filtry, aby se dotaz neposílal na každý
 * úhoz. `value` se propíše do výstupu až po `delayMs` bez další změny.
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
